/* External dependencies */
import { gql } from "@apollo/client";

/* Local dependencies */
import { authenticatedClient } from "../../../../client/graphql";
import { UpdateUserInput, User } from '../../../users/types';

export const updateUser = (input: UpdateUserInput): Promise<User> => {
  return authenticatedClient.mutate({
    mutation: gql`
      mutation T26UpdateUser($input: T26UpdateUserInput!) {
        T26UpdateUser(input: $input) {
          id
          name
          email
          avatar
          points
        }
      }
    `,
    variables: { input },
  }).then((res) => {
    console.log('User updated: ', res.data.T26UpdateUser);
    return res.data.T26UpdateUser;
  }).catch((err) => {
    console.error(err, 'Error updating user in frontend: ');
    throw err;
  });
};
